import { render, staticRenderFns } from "./SlidesViewTab.vue?vue&type=template&id=5ac4b18b&scoped=true&"
import script from "./SlidesViewTab.vue?vue&type=script&lang=js&"
export * from "./SlidesViewTab.vue?vue&type=script&lang=js&"
import style0 from "./SlidesViewTab.vue?vue&type=style&index=0&id=5ac4b18b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac4b18b",
  null
  
)

export default component.exports